export class PAReviewMeetingParticipantsModel {
    constructor() {
        this.name = "";
        this.isSelected = false;
        this.isUnEditable = false;
        this.isParticipantPaAdmin = false;
        this.email = "";
    }
}
export default class PAReviewMeetingParticipants extends PAReviewMeetingParticipantsModel {
    constructor(model) {
        super();
        Object.assign(this, model);
    }
}
